<template>
  <div>
    <h1>welcome to admin panel</h1>
  </div>
</template>

<script>
export default {
name:"admin-pavle"
}
</script>

<style>

</style>